if (!customElements.get('new-mega-menu')) {
  class NewMegaMenu extends HTMLElement {
    constructor() {
      super();

      // Init elements
      this.buttons = this.querySelectorAll('.new-mega-menu__nav-button');
      this.links = this.querySelectorAll('.new-mega-menu__nav-link');
      this.modal = this.querySelector('.new-mega-menu__modal');
      this.dropdowns = this.querySelectorAll('.new-mega-menu__dropdown');
      this.header = document.querySelector('sticky-header');
      this.headerFirstChild = this.header?.firstElementChild;

      this.setupEventListeners();
    }

    setupEventListeners() {
      this.buttons.forEach((button, index) => {
        button.addEventListener('mouseover', () => this.openDropdown(index));
      });

      // Close modal if mouse leaves the modal background
      this.modal.addEventListener('mouseleave', (event) => {
        if (!this.isMovingDown(event)) {
          this.closeModal();
        }
      });

      // Close modal if mouse leaves the first child of the header (only if moving up/left/right)
      if (this.headerFirstChild) {
        this.headerFirstChild.addEventListener('mouseleave', (event) => {
          if (!this.isMovingDown(event)) {
            this.closeModal();
          }
        });
      }

      this.dropdowns.forEach(dropdown => {
        dropdown.addEventListener('mouseleave', () => this.closeModal());
      });

      this.links.forEach(link => {
        link.addEventListener('mouseleave', () => this.closeModal());
        link.addEventListener('mouseover', () => this.closeModal());
      });

      // Close modal when clicking on its background
      this.modal.addEventListener('click', (event) => {
        if (event.target === this.modal) {
          this.closeModal();
        }
      });
    }

    openDropdown(index) {
      this.setModalTopPosition();
      this.modal.setAttribute('data-open', '');
      document.body.style.overflow = 'hidden';

      this.buttons.forEach(b => b.removeAttribute('data-active'));
      this.buttons[index].setAttribute('data-active', '');

      this.dropdowns.forEach(d => d.removeAttribute('data-show'));
      this.dropdowns[index].setAttribute('data-show', '');
    }

    closeModal() {
      this.modal.removeAttribute('data-open');
      document.body.style.overflow = '';
      this.dropdowns.forEach(d => d.removeAttribute('data-show'));
      this.buttons.forEach(b => b.removeAttribute('data-active'));
    }

    setModalTopPosition() {
      const headerRect = this.header.getBoundingClientRect();
      this.modal.style.top = `${headerRect.height - 1 + headerRect.top}px`;
    }

    isMovingDown(event) {
      return event.relatedTarget && event.relatedTarget.closest('.new-mega-menu__dropdown');
    }
  }

  customElements.define('new-mega-menu', NewMegaMenu);
}
